<template>
   <div>
     <b-row v-if="loadingData">
      <b-col>
        <spinner style="margin-top: 20px;"></spinner>
      </b-col>
    </b-row>
    <b-row v-else-if="nothingAvailable">
      <b-col>
        <h4>Nada Encontrado</h4>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col sm="12">
        <b-card v-if="items && items.length > 0 && !loadingData" :header="caption">
          <b-table
            :dark="dark"
            hover
            striped
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            :items="items"
            :fields="captions"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template #cell(priority)="data">
              <a v-bind:href="'/admin/creation/update/' + data.item._id" target="_blank">
                <div>{{data.item.priority ? "Alta" : "Normal"}}</div>
              </a>
              <b-badge variant="info" v-if="(filter == 2 || filter == 6) && data.item.artLink && data.item.artLink.length && !data.item.sleekerLink">Arte Criada</b-badge>
              <b-badge variant="primary" v-if="(filter == 2  || filter == 6) && data.item.artLink && data.item.artLink.length && data.item.sleekerLink">Sleeker Cadastrado</b-badge>
              <b-badge variant="info" v-if="(filter == 4 || filter == 2) && data.item.review">Revisão Pendente</b-badge>
            </template>
            <template #cell(story)="data">
              <b-badge variant="success" v-if="data.item.story">Story</b-badge>
              <b-badge variant="info" v-else>Post</b-badge>
            </template>
            <template #cell(creationDate)="data">
              <!-- <b-button size="sm" @click="showDetails(data.item._id)"> -->
              <a v-bind:href="'/admin/creation/update/' + data.item._id" target="_blank">
                <div v-bind:class="{'redAlert': isLate(data.item)}">
                  {{data.item.creationDate | moment("DD/MM/YYYY HH:mm")}}
                  <b-badge variant="danger" v-if="isLate(data.item)">Atrasado</b-badge>
                </div>
              </a>
              <!-- </b-button> -->
            </template>
            <template #cell(requester)="data">
              <a v-bind:class="{'redAlert': isLate(data.item)}" v-bind:href="'/admin/creation/update/' + data.item._id" target="_blank">
                <div>{{data.item.requester}}</div>
              </a>
            </template>
            <template #cell(requesterType)="data">
              <a v-bind:class="{'redAlert': isLate(data.item)}" v-bind:href="'/admin/creation/update/' + data.item._id" target="_blank">
                <div>{{getTypeName(data.item.requesterType)}}</div>
              </a>
            </template>
            <template #cell(request)="data">
              <a v-bind:href="'/admin/creation/update/' + data.item._id" target="_blank">
                <b-badge variant="success" v-if="data.item.controller">{{data.item.controller}}</b-badge>
                <div> {{data.item.request ? data.item.request.substr(0,100) +'...' : ""}}</div>
              </a>
            </template>
          </b-table>
          <nav>
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Anterior"
              next-text="Próxima"
              hide-goto-end-buttons
            />
          </nav>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";

export default {
  name: "CreationList",
  inheritAttrs: false,
  props: {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 20
    },
    dark: {
      type: Boolean,
      default: false
    },
    whitelabel: false,
    filter: 0,
    creations: undefined,
    filterRequester: 0,
    filterController: 0,
    filterType: 0
  },
  data: () => {
    return {
      currentPage: 1,
      emailSearch: undefined,
      phoneSearch: undefined,
      nameSearch: undefined,
      accountType: undefined,
      subscriptionStatus: undefined,
      nothingAvailable: false,
      userDetails: [],
      loadingData: false,
      info: {},
      caption: ""
    };
  },
  computed: {
    items: function() {
      let result = this.creations;
      if (this.filterRequester) {
        let filteredCreations = [];
        for (let key in this.creations) {
          let creation = this.creations[key];
          if (creation.requester.toLowerCase() == "interno") {
            if (this.filterRequester == 1) {
              filteredCreations.push(creation);
            }
          } else if (creation.requester.toLowerCase() == "sleekerbr") {
            if (this.filterRequester == 3) {
              filteredCreations.push(creation);
            }
          } else if (creation.requester.toLowerCase() == "receita") {
            if (this.filterRequester == 4) {
              filteredCreations.push(creation);
            }
          } else if (this.filterRequester == 2) {
            filteredCreations.push(creation);
          }
          result = filteredCreations;
        }
        
      } 

      if (this.filterController) {
        let filteredByController = [];

        for (let key in result) {
          if (result[key].control == this.filterController) {
            filteredByController.push(result[key]);
          }
        }

        result = filteredByController;
      }

      if (this.filterType) {
        console.log("filterType");
        console.log(this.filterType);
        let filteredByType = [];

        for (let key in result) {
          if (result[key].requesterType == this.filterType) {
            filteredByType.push(result[key]);
          }
        }

        result = filteredByType;
      }

      return result;
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    },
    fields: function() {
      let baseFields = [
        {
          key: 'priority',
          label: "Prioridade",
          sortable: true
        },
        {
          key: "story",
          label: "Formato",
          sortable: true
        },
        {
          key: "creationDate",
          label: "Data Solicitação",
          sortable: true
        },
        {
          label: "Solicitante",
          sortable: true,
          key: "requester"
        },
        {
          label: "Tipo de Solicitante",
          sortable: true,
          key: "requesterType"
        },
        {
          label: "Pedido",
          sortable: true,
          key: "request"
        }];

      return baseFields;
    }
  },
  methods: {
    isLate: function(creation) {
      let date = creation.creationDate;
      let paramDate = new Date();

      paramDate.setDate((paramDate.getDate() - 10));

      let requestDate = new Date(date);

      if (requestDate.getTime() < paramDate.getTime()) {
        if (creation.requester != "receita" && creation.requester != "sleekerbr" && creation.requester != "interno" && creation.requester != "Interno") {
          return true;
        }
      } 
      return false;
    },
    getRowCount: function() {
      return this.items.length;
    },
    getTypeName(type) {
      let name = "-";

      if (type) {
        if (type == "1") {
          name = "Nutri"
        } else if (type == "2") {
          name = "Personal"
        } else if (type == "3") {
          name = "Psico"
        }
      }

      return name;
    }
  },
  components: { Spinner },
  created() {
    
  }
};
</script>


<style>
  .redAlert {
    color: red;
  }
</style>